import React from 'react';
import SponsoredInfoIcon from '../../../atoms/Icon/assets/svgs/sponsored-icon.svg?inline';
import {Sponsored, SponsoredProps} from './Sponsored';

export const SponsoredWithBlurIcon: React.FC<SponsoredProps> = props => {
  return <Sponsored {...props} icon={SponsoredInfoIcon} iconSize="S" />;
};
